import type { ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { AuthStateBridge } from './session/AuthStateBridge'
import { AnalyticsBridge } from './session/AnalyticsBridge'
import { LocaleProvider } from './i18n/LocaleContext'

/**
 * Everything the shared shell needs around the app, in the one order that
 * works. Call configureProduct() before rendering this.
 */
export function PlatformProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {/* Owns the single auth subscription; must be inside the provider. */}
      <AuthStateBridge />
      {/* Reads the session, so it sits inside the provider too. */}
      <AnalyticsBridge />
      {/* Reads the profile query, so it sits inside the provider. */}
      <LocaleProvider>{children}</LocaleProvider>
    </QueryClientProvider>
  )
}
